import { env, WHITELISTING_ENABLED } from "@/config/env";
import { externalLinks } from "@/constants/links";
import { PRODUCTS_MENU_LINKS } from "@/components/ProductsMenu/constants";

const isWaitlistEnabled = WHITELISTING_ENABLED && env.WAITLIST_URL;

export const SOLUTIONS_MENU_LINKS = [
  {
    title: "Ticketing",
    description: "",
    url: "/contact",
    newTab: false,
    icon: "solutions-icon",
  },
  {
    title: "Loyalty & Rewards",
    description: "",
    url: "/contact",
    newTab: false,
    icon: "solutions-icon",
  },
  {
    title: "Redemptions",
    description: "",
    url: "/contact",
    newTab: false,
    icon: "solutions-icon",
  },
  {
    title: "Identity",
    description: "",
    url: "/contact",
    newTab: false,
    icon: "solutions-icon",
  },
];

export const LINKS = [
  {
    title: "Products",
    url: "",
    children: PRODUCTS_MENU_LINKS,
  },
  // { title: "Solutions", url: "", children: SOLUTIONS_MENU_LINKS },
  {
    title: "Pricing",
    url: "/pricing",
    newTab: false,
  },
  {
    title: "Resources",
    url: "",
    children: [
      {
        title: "View Docs",
        url: externalLinks.documentation,
        newTab: true,
        icon: null,
      },
      {
        title: "Blog",
        url: externalLinks.blog,
        newTab: true,
        icon: null,
      },
    ],
  },
  {
    title: "About",
    url: "/about",
    newTab: false,
  },
  {
    title: "Contact",
    url: "/contact",
    newTab: false,
  },
];

export const BUTTONS: {
  title: string;
  url: string;
  primary?: boolean;
}[] = [
  {
    title: "Docs",
    url: env.DOCUMENTATION_URL,
  },
];

export type NavProps = {
  title: string;
  url: string;
  newTab?: boolean;
  children?: NavProps[];
};
